module.exports = ".not-active {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}"